var React = require('react');

function MarketingVector3 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M45 11V0.5M45 65.0938V75.5938M26.25 14.0933L21 5M26.25 62.0005L21 71.0938M64 14.0933L69.25 5M64 62.0005L69.25 71.0938M88 38C88 38 68.7482 59 45 59C21.2518 59 2 38 2 38C2 38 21.2518 17 45 17C68.7482 17 88 38 88 38ZM61 38C61 46.8366 53.8366 54 45 54C36.1634 54 29 46.8366 29 38C29 29.1634 36.1634 22 45 22C53.8366 22 61 29.1634 61 38ZM51 38C51 41.3137 48.3137 44 45 44C41.6863 44 39 41.3137 39 38C39 34.6863 41.6863 32 45 32C48.3137 32 51 34.6863 51 38Z","stroke":"#FCB34E","strokeWidth":"2"}));
}

MarketingVector3.defaultProps = {"width":"90","height":"76","viewBox":"0 0 90 76","fill":"none"};

module.exports = MarketingVector3;

MarketingVector3.default = MarketingVector3;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/images/marketing_vector_3.svg
// module id = 944
// module chunks = 0